<script>
    import { quill } from "svelte-quill";

    let options = { placeholder: "Transcribe here..." };

    let content = { html: "", text: "" };

    export let title;
</script>

<style>
    .editor__container {
        padding: 5px;
        min-width: 145px;
    }

    :global(.ql-editor) {
        background-color: whitesmoke;
        tab-size: 20;
        -moz-tab-size: 20;
        -o-tab-size: 20;
        font-family: "Work Sans", sans-serif;
    }

    .editor__title {
        font-family: "Libre Baskerville", serif;
        font-size: 18px;
        text-align: center;
    }

    .indexer {
		grid-area: indexer;
		background-color: var(--white);
	}
</style>

<svelte:head>
    <link href="//cdn.quilljs.com/1.3.6/quill.snow.css" rel="stylesheet" />
</svelte:head>

<div class="indexer">
    <div class="editor__container">
        <h1 class="editor__title">{title}</h1>
        <div
            class="editor"
            use:quill={options}
            on:text-change={(e) => (content = e.detail)} />

        <br />

        <!-- {@html content.html} -->
        {content.html}
    </div>
</div>
